/*=========================================================================================
  File Name: moduleDocumentUploadMutations.js
  Description: DocumentUpload Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  SET_DOCUMENTTYPES(state, payload) {
    state.documenttypes = payload;
  },
};
